export const getRegnum = identifiers => {
  const id = identifiers.find(x => x.idtype && x.idtype === 'reg_number');
  return id ? id.value : '';
};

export default {
  getRegnum,
};
